// WeekSelector.js
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const WeekSelector = ({ onWeekChange, weekRange = { startOfWeek: '', endOfWeek: '' } }) => {
    const [selectedDate, setSelectedDate] = useState('');
    // Sync input when parent changes weekRange
    useEffect(() => {
        if (weekRange?.startOfWeek) {
            setSelectedDate(weekRange.startOfWeek);
        }
    }, [weekRange]);

    // Function to calculate the start and end of the week for a given date
    const calculateWeekRange = (date) => {
        const startOfWeek = new Date(date);
        const dayOfWeek = startOfWeek.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
        const diffToMonday = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek; // Adjust for Sunday being 0
        startOfWeek.setDate(startOfWeek.getDate() + diffToMonday);

        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);

        return {
            startOfWeek: startOfWeek.toISOString().split('T')[0], // Format as YYYY-MM-DD
            endOfWeek: endOfWeek.toISOString().split('T')[0]
        };
    };

    const handleDateChange = (e) => {
        const date = new Date(e.target.value);
        setSelectedDate(e.target.value);

        const newWeekRange = calculateWeekRange(date);
        onWeekChange(newWeekRange); // Notify parent component
    };

    return (
        <div className="week-selector">
            <label htmlFor="date-select" className="week-selector-label">
                Select a Date:
            </label>
            <input
                type="date"
                id="date-select"
                value={selectedDate}
                onChange={handleDateChange}
                className="week-selector-input"
            />
            <div className="week-range">
                <p>Start of Week: {weekRange.startOfWeek}</p>
            </div>
            <div className="week-range">
                <p>End of Week: {weekRange.endOfWeek}</p>
            </div>
        </div>
    );
};

WeekSelector.propTypes = {
    onWeekChange: PropTypes.func.isRequired // Callback function to pass start and end of the week
};

export default WeekSelector;